import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { Subject } from 'rxjs/Subject';
import { finalize, takeUntil } from 'rxjs/operators';
import { CustomizedLabels, NavBreadcrumb, User } from '@models/models';
import { SettingsProvider } from '@services/settings/settings';

@Component({
	selector: 'customize-labels',
	template: require('./customize-labels.html'),
	styles: [require('./customize-labels.scss')]
})
export class CustomizeLabelsComponent implements OnInit, OnDestroy {
	@Input() labelsData: CustomizedLabels;
	@Output() onLabelsDataChange: EventEmitter<void> = new EventEmitter();

	disableButton: boolean;
	unsubscribe: Subject<void> = new Subject<void>();

	breadcrumbs: Array<NavBreadcrumb> = [
		{ link: '/', title: 'Dashboard' },
		{ link: '/settings', title: 'Settings' },
		{ link: null, title: 'Labels' }
	];
	constructor(
		private settingsService: SettingsProvider,
		private messageService: MessageService
	) {}

	ngOnInit(): void {
		this.subscribeToPanelsPosition();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	saveData(): void {
		if (this.isDataValid()) {
			this.disableButton = true;
			this.settingsService
				.saveCustomizedLabels(this.labelsData)
				.pipe(
					takeUntil(this.unsubscribe),
					finalize((): boolean => (this.disableButton = false))
				)
				.subscribe(
					(): void => this.successDataChange(),
					(): void => this.messageService.showToaster('e_0', 'general')
				);
		}
	}

	private successDataChange(): void {
		this.onLabelsDataChange.emit();
		this.settingsService.setCustomizeLabels(this.labelsData);
		this.messageService.showToaster('s_0', 'customizeLabels');
	}

	private subscribeToPanelsPosition(): void {
		this.settingsService.customizeLabelsObservable
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				(data: CustomizedLabels): CustomizedLabels => (this.labelsData = data),
				(error): void => this.messageService.showDefaultErrorMessage(error)
			);
	}

	private isDataValid(): boolean {
		let isFilled = true;

		Object.keys(this.labelsData).forEach((key: string): void => {
			if (!this.labelsData[key] || !this.labelsData[key].trim()) {
				isFilled = false;
			}
		});

		if (!isFilled) {
			this.messageService.showToaster('e_0', 'customizeLabels');
			return false;
		}

		if (/\s/.test(this.labelsData.shootsLabel)) {
			this.messageService.showToaster('e_1', 'customizeLabels');
			return false;
		}

		return true;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/customize-labels/customize-labels.ts